import jsc from "js-cookie";

export function getFromCookie(name: string) {
  const cookieValue = jsc.get(name);

  if (cookieValue) {
    try {
      return JSON.parse(cookieValue) as unknown;
    } catch {
      console.error("Could JSON.parse cookie value.");
      return null;
    }
  }

  return null;
}

export function removeCookie(name: string) {
  jsc.remove(name);
}

export function getStringArrayFromCookie(name: string) {
  return (getFromCookie(name) as string[]) ?? [];
}
